module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><div><label for="alarm-message-input">'+
((__t=( i18n.tc("UnitAlarm", "Alarm message") ))==null?'':__t)+
'</label> <input placeholder="'+
((__t=( i18n.tc('UnitAlias', 'Alarm!')))==null?'':__t)+
'" type="text" id="alarm-message-input" data-input="alarm-message" value="'+
((__t=( message ))==null?'':__t)+
'" required></div><p class="input">'+
((__t=( i18n.tc("UnitAlarm", "Enter an alarm message that will follow any alarms from the general alarm input (wired alarm) on your unit.") ))==null?'':__t)+
'</p></fieldset><fieldset class="button-wrap"><button class="primary" data-click="alias-submit" hidden>'+
((__t=( i18n.tc("UnitAlarm", "Save") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
